/**
 * Simulate click event on body
 */
export const simulateClickBody = () => {
	const evt = new MouseEvent('click', {
		bubbles: true,
		cancelable: true,
		view: window,
	});
	const canceled = !document.body.dispatchEvent(evt);
};
